"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const ads_1 = require("./ads");
exports.contentConversionStepDetailData = graphql_tag_1.default `
  fragment contentConversionStepDetailData on ContentConversionStep {
    attributeName
    attributeRemovalStrategy
    attributes
    attributeValue
    cssForATag
    cssForImgTag
    doNothingIfAttributeExists
    fromAttribute
    headHtml
    id
    imgWidth
    includedHtml
    linkSelector
    linkToContentItem
    linkToFirstLink
    name
    order
    adjacentInsertionPosition
    ad {
      ...adDetailData
    }
    overlayHtml
    removeTarget
    selector
    textToFind
    textToReplace
    toAttribute
    type
    paused
  }
  ${ads_1.adDetailData}
`;
//# sourceMappingURL=contentConversionSteps.js.map